import {useEffect, useCallback} from 'react';

const useCalculatePercent = (
  min: number,
  max: number,
  minVal: number,
  maxVal: number,
  maxValRef: React.RefObject<HTMLInputElement>,
  range: React.RefObject<HTMLDivElement>,
): void => {
  const getPercent = useCallback(
    (value: number) => Math.round(((value - min) / (max - min)) * 100),
    [min, max],
  );

  useEffect(() => {
    if (maxValRef.current) {
      const minPercent = getPercent(minVal);
      const maxPercent = getPercent(+maxValRef.current.value);

      if (range.current) {
        range.current.style.right = `${minPercent}%`;
        range.current.style.width = `${maxPercent - minPercent}%`;
      }
    }
  }, [getPercent, maxValRef, range, minVal, maxVal]);
};

export default useCalculatePercent;
